<template>
  <div class="pc-list" ref="list">
    <MagazineArticleSearch @search="search" ref="reSearch" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteMagazineArticleInit">删除</button>
          <span></span>
          <button @click="addMagazineArticle">添加</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="articleList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="articleList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="id"
        label="ID"
        sortable="custom"
        width="100"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cover_image" label="图片" width="110" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.cover_image" :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="title" label="标题" width="180">
        <template slot-scope="scope">
          <div>
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="author" label="作者" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.author">
            {{ scope.row.author | scholarname }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" sortable="custom" width="110">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="start_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.start_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="结束时间"
        prop="end_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.end_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="articleDialog"
      :title="ArticleDetail.title"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="图片">
          <UploadImage
            :img="ArticleDetail.cover_image"
            :width="220"
            :height="180"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="ArticleDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="作者">
          <keywordsinput
            :maxLen="18"
            :key="1"
            v-model="ArticleDetail.author"
          ></keywordsinput>
        </el-form-item>
        <el-form-item label="简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="ArticleDetail.description"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select
            v-model="ArticleDetail.classification"
            multiple
            placeholder="请选择"
            value-key="english_name"
          >
            <el-option
              v-for="item in articleClassificationList"
              :key="item.label"
              :label="item.english_name"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件">
          <UploadFile
            :file="ArticleDetail.origin_pdf"
            @getUploadFile="getUploadSource"
            :title="'文件'"
          ></UploadFile>
        </el-form-item>
        <el-switch
          v-model="ArticleDetail.status"
          active-color="#91CC75"
          inactive-color="#C7C7C7"
          :active-value="1"
          :inactive-value="0"
          style="margin-left: 40px"
        >
        </el-switch>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(ArticleDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="articleList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import DeleteHint from "@/components/template/DeleteHint";
import MagazineArticleSearch from "./MagazineArticleSearch";
import UploadImage from "../../../componentSet/uploadImage.vue";
import UploadFile from "../../../componentSet/uploadFile.vue";
import {
  getNewsList_Api,
  deleteNewsList_Api,
  updateNewsDetail_Api,
  createNewsDetail_Api,
} from "@/apis/magazine.api";
export default {
  components: {
    Pagination,
    DeleteHint,
    MagazineArticleSearch,
    UploadImage,
    UploadFile,
  },
  data() {
    return {
      loading: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      ArticleDetail: {
        author: "",
        magazine_topic: null,
        magazine_article_id: null,
        classification: [],
        classification_list: [],
      },
      articleClassificationList: [],
      isSelectAll: false,
      articleList: [],
      checked: [],
    };
  },
  filters: {
    scholarname: function (value) {
      for (let i in value) {
        return value.toString();
      }
    },
  },
  mounted() {
    this.getArticleListByRules(this.searchRules);
  },
  methods: {
    getUploadImage(img_url) {
      this.ArticleDetail.cover_image = img_url;
    },
    getUploadSource(file_url) {
      this.ArticleDetail.origin_pdf = file_url;
    },
    // 获取
    getArticleListByRules(data) {
      this.loading = true;
      getNewsList_Api(data)
        .then((res) => {
          console.log(res);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.articleList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.articleList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.articleList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }

      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getArticleListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/newsLatterDetail",
        query: {
          id: item.id,
          news_id: this.$route.query.id,
          content_type: "news",
          method: "update",
        },
        name: "newsDetail",
        params: item,
      });
      window.open(route.href, "_blank");
    },

    // 修改状态
    changeState(row) {
      updateNewsDetail_Api({
        news_id: row.id,
        status: row.status,
        title: row.title,
      })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getArticleListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.isSelect) {
        data.isSelect = formData.isSelect;
      }
      if (formData.status) {
        data.status = parseInt(formData.status);
      }
      if (formData.classification_id) {
        data.classification_id = parseInt(formData.classification_id);
      }
      if (formData.title_keywords) {
        data.title_keywords = formData.title_keywords;
      }

      return data;
    },
    isDelete() {
      let delete_ids = { news_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteNewsList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          let data = this.dealSearchRules(this.searchRules);
          this.getArticleListByRules(data);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    deleteMagazineArticleInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的词条！", null);
      }
    },
    addMagazineArticle() {
      let route = this.$router.resolve({
        path: "/admin/newsLatterDetail",
        query: { method: "add" },
      });
      window.open(route.href, "_blank");
    },
    submitBanner(item) {
      if (this.ArticleDetail.id == null) {
        // this.magazineTopicDetailList.magazine = this.themeList[0].magazine
        this.ArticleDetail.magazine_topic = this.magazine_topic_id;
        this.ArticleDetail.author = this.ArticleDetail.author.toString();
        delete this.ArticleDetail.update_time;
        delete this.ArticleDetail.create_time;
        if (this.ArticleDetail.classification.length != 0) {
          this.ArticleDetail.classification_list =
            this.ArticleDetail.classification.map((item) => {
              return item.id;
            });
        }

        if (!this.ArticleDetail.classification_list) {
          delete this.ArticleDetail.classification_list;
        }
        if (!this.ArticleDetail.origin_pdf) {
          delete this.ArticleDetail.origin_pdf;
        }
        createNewsDetail_Api(item).then((res) => {
          console.log(res);
          this.getArticleListByRules();
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        this.ArticleDetail.author = this.ArticleDetail.author.toString();
        delete this.ArticleDetail.update_time;
        delete this.ArticleDetail.create_time;
        if (this.ArticleDetail.classification.length != 0) {
          this.ArticleDetail.classification_list =
            this.ArticleDetail.classification.map((item) => {
              return item.id;
            });
        }

        if (!this.ArticleDetail.classification_list) {
          delete this.ArticleDetail.classification_list;
        }
        if (!this.ArticleDetail.origin_pdf) {
          delete this.ArticleDetail.origin_pdf;
        }
        updateArticleDetail_Api(this.ArticleDetail).then((res) => {
          this.ArticleDetail.magazine_topic = this.magazine_topic_id;
          console.log(res);
          this.getArticleListByRules();
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getArticleListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
/deep/ .el-dialog {
  width: 70% !important;
}
/deep/.el-form
  .el-form-item
  .el-form-item__content
  div
  .logoImg
  .el-upload__tip {
  margin-top: -10px;
}
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
/deep/ button.el-button.el-button--primary.el-button--small {
  padding: 0;
  background: #fff;
  color: #000;
  border: none;
}
/deep/ .el-icon-document:before {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/components/MagazineArticleTable.vue